/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 01.06.17.
 */

import React from "react";
import PropTypes from "prop-types";
import _ from "underscore";

import RestrictionCalculator from "../../RestrictionCalculator";
import {SessionStore} from "../../services/Session";

class ActionButtons extends React.Component {

    static propTypes = {
        /**
         * Actions
         */
        actions: PropTypes.arrayOf(PropTypes.shape({
            icon: PropTypes.string,
            label: PropTypes.string,
            action: PropTypes.string.isRequired,
            href: PropTypes.string,
            params: PropTypes.object,
            data: PropTypes.object,
            btnClass: PropTypes.string,
            isPrimary: PropTypes.bool,
            restriction: PropTypes.string,
            access: PropTypes.string
        })),
        /**
         * @type {OnActionCallback}
         */
        onAction: PropTypes.func,
        className: PropTypes.string,
        defaultBtnClass: PropTypes.string,
        type: PropTypes.oneOf(["group", "single"]),
        location: PropTypes.object
    };

    static defaultProps = {
        defaultBtnClass: "btn-sm btn-outline btn-default",  // btn-primary btn-outline
        type: "group"
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    onClick(action) {
        if (this.props.onAction) this.props.onAction(action);
    }

    /**
     * Return array of action buttons
     * @return {Array}
     */
    renderButtons() {
        let currentPath = this.props.location.pathname;

        let buttons = [];
        let i = 0;
        for (let item of this.props.actions) {
            if (!item.label && !item.icon) continue;
            if (item.access && !SessionStore.isAuthorized(item.access)) continue;
            if (item.restriction) {
                let restrictionCalculator = new RestrictionCalculator(item.params, item.data);
                if (!restrictionCalculator.isSatisfied(item.restriction)) continue;
            }

            let btnClass = item.btnClass;
            let disabled = null;
            if (btnClass && btnClass.indexOf("disabled") >= 0) {
                disabled = "disabled";
                btnClass = btnClass.replace("disabled", "").trim();
                btnClass = null;
            }
            if (!btnClass) btnClass = this.props.defaultBtnClass;
            let btnType = "button";
            if (item.isPrimary) {
                btnType = "submit";
                if (!item.btnClass) {
                    // Replace "btn-default" => "btn-primary"
                    let btnClassArray = _.filter(btnClass.split(" "), function (v) {
                        return v !== "btn-default";
                    });
                    btnClassArray.push("btn-primary");
                    btnClass = btnClassArray.join(" ");
                }
            }
            buttons.push(
                <button
                    key={i++}
                    type={btnType}
                    disabled={disabled}
                    className={"btn " + btnClass}
                    onClick={() => this.onClick(item)} >{item.icon ? <span className={"fa fa-" + item.icon}/> : ""}{item.icon ? " " : ""}{item.label}</button>
            );
        }
        return buttons;
    }

    render() {
        if (!this.props.actions) return null;
        let buttons = this.renderButtons();
        if (buttons.length == 0) return null;
        return (
            <div className={(this.props.type === "group" ? "btn-group" : "") + (this.props.className ? " " + this.props.className : "")}>
                {buttons}
            </div>
        );
    }
}

export default ActionButtons;
